import React, {Component} from 'react'

import {Col} from "react-bootstrap";

export default class WidgetListItem extends Component {


    onOptionSelected = (e) => {
        this.props.onItemChecked(e);
    };

    randomStyle = (i) => {
        // return i%2 === 0 ? "cardBorderPrimary" : "cardBorderSecondary"
        return ""
    };

    render() {
        let item = this.props.widget;
        let position = this.props.position;
        let checkedClass = this.props.checked ? 'widget-list-checked' : '';
        return (
            <Col md={4} className="card-widget-spacing" onClick={() => this.onOptionSelected(item)}>
                <div className={`card border-0 card-widget-header ${checkedClass}`}>
                    <div className={`card-header card-header-widget-item  ${this.randomStyle(position)}`}>
                        {item.name}
                    </div>
                </div>
            </Col>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/Widgets/WidgetListItem.jsx